import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import ViewAttachment from '../../ComplainHandling/components/ViewAttachment';
import CustomDescription from '../../../components/CustomDescription';
import CustomVideo from '../../../components/CustomVideo';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import appUrl from "../../../../constants/appUrl";
const TableProcessInformation = ({ callCenter, searchQuery }) => {

    const [viewAttachmentDialog, setViewAttachmentDialog] = useState(false);
    const [selectedAttachment, setSelectedAttachment] = useState(null);
    const [dialog, setDialog] = useState();
    const [tableData, setTableData] = useState([]);
    const [descriptionDialog, setDescriptionDialog] = useState(false);
    const [descriptionContent, setDescriptionContent] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [videoAttachmentDialog, setVideoAttachmentDialog] = useState(false);
    const [selectedVideoAttachment, setSelectedVideoAttachment] = useState(null);
    useEffect(() => {
        setTableData(callCenter)
    }, [callCenter])

    const onHideViewAttachment = () => {
        setViewAttachmentDialog(false);
    };
    const onHide = () => {
        setDialog(false)
    }
    const actionDocument = (rowData) => {
        const documentsToDownload = rowData.processAttachments.filter(attachment =>
            attachment.attachmentPath.endsWith('.docx') ||
            attachment.attachmentPath.endsWith('.pdf') ||
            attachment.attachmentPath.endsWith('.xlsx')
        );

        const documentPaths = documentsToDownload.map(document => document.attachmentPath);
         const hasImage = rowData?.processAttachments?.some(attachment => attachment?.attachmentPath?.endsWith('.png') || attachment?.attachmentPath?.endsWith('.jpg') || attachment?.attachmentPath?.endsWith('.jpeg'));
        const hasVideo = rowData.processAttachments.some(attachment => attachment.attachmentPath.endsWith('.mp4') || attachment.attachmentPath.endsWith('.mp5') || attachment.attachmentPath.endsWith('.webm')|| attachment.attachmentPath.endsWith('.mov')|| attachment.attachmentPath.endsWith('.3gp')|| attachment.attachmentPath.endsWith('.3g2')|| attachment.attachmentPath.endsWith('.mpeg'));

        return (
            <div>
                 {documentsToDownload.length > 0 && (
                    <Button
                        icon="pi pi-download"
                        className="custom-btn-edit"
                        onClick={() => downloadDocuments(documentPaths)}
                    />
                )}
                {hasImage && (
                    <Button icon="pi pi-eye" className="custom-btn-edit" onClick={() => {
                        setSelectedAttachment(rowData.processAttachments.filter(attachment => attachment.attachmentPath.endsWith('.png') || attachment.attachmentPath.endsWith('.jpg') || attachment.attachmentPath.endsWith('.jpeg')));
                        setViewAttachmentDialog(true);
                    }} />
                )}
                {hasVideo && (
                    <Button icon="pi pi-video" className="custom-btn-edit" onClick={() => {
                        setSelectedVideoAttachment(rowData.processAttachments.filter(attachment => attachment.attachmentPath.endsWith('.mp4') || attachment.attachmentPath.endsWith('.mp5') || attachment.attachmentPath.endsWith('.webm')|| attachment.attachmentPath.endsWith('.mov')|| attachment.attachmentPath.endsWith('.3gp')|| attachment.attachmentPath.endsWith('.3g2')|| attachment.attachmentPath.endsWith('.mpeg')));
                        setVideoAttachmentDialog(true);
                    }} />
                )}
                {(documentsToDownload.length === 0 && !hasImage && !hasVideo) && (
                <Button
                    // icon="pi pi-question"
                    label='-'
                    className="custom-btn-edit"
                    tooltip="No attachment available"
                />
            )}
            </div>
        );
    }
    const showDescription = (description) => {
        setDescriptionContent(description);
        setDescriptionDialog(true);
    };
    const onHideDescriptionDialog = () => {
        setDescriptionDialog(false);
    };

    const onHideVideoAttachment = () => {
        setVideoAttachmentDialog(false);
    };
    useEffect(() => {
        if (searchQuery) {
            setFilteredData(
                tableData?.filter((item) =>
                    item.policyPrefix?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
                item.processName?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
                item.productName?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
                item.channelName?.toLowerCase().includes(searchQuery?.toLowerCase())
                )
            );
        } else {
            setFilteredData(tableData);
        }
    }, [searchQuery, tableData]);

    const downloadDocuments = async (documentPaths) => {
        try {
            for (let i = 0; i < documentPaths.length; i++) {
                const documentPath = documentPaths[i];
                const response = await fetch(`${appUrl.baseUrl}${documentPath}`);
                const blob = await response.blob();
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', '');
                link.setAttribute('target', '_blank');
                link.click();
                URL.revokeObjectURL(url);
                await new Promise(resolve => setTimeout(resolve, 1000)); // Delay each download by 1 second
            }
        } catch (error) {
            console.error("Error downloading documents:", error);
            toast.error("Failed to download documents");
        }
    };

    return (
        <> <ToastContainer />

            <Dialog visible={viewAttachmentDialog} onHide={onHideViewAttachment} header="View Attachment" style={{ width: '50vw' }}>
                {selectedAttachment && <ViewAttachment attachment={selectedAttachment} />}
            </Dialog>
            <Dialog visible={descriptionDialog} onHide={onHideDescriptionDialog} header="Description" style={{ width: '50vw' }}>
                <CustomDescription description={descriptionContent} />
            </Dialog>
            <Dialog visible={videoAttachmentDialog} onHide={onHideVideoAttachment} header="View Video Attachment" style={{ width: '50vw' }}>
                {selectedVideoAttachment && <CustomVideo videoAttachments={selectedVideoAttachment} />}
            </Dialog>

            <div className=''>


                <div className='grid'>
                    <div className='md:col-12 overflowX' >
                        <div className='table-custom'>
                            <DataTable
                                value={filteredData}
                                scrollable
                                scrollHeight="600px"
                                rows={9}
                                paginator
                            >
                                <Column field='productName' header="Product " />
                                <Column field='channelName' header="Channel " />
                                {/* <Column field='processName' header="Process " /> */}
                                <Column header="Process" className='pointer' body={(rowData) => (
                                <span title={rowData.processName}>
                                    {rowData.processName?.length > 15 ? `${rowData.processName.slice(0, 15)}...` : rowData.processName}
                                </span>
                            )} />
                               
                                 <Column header="Prefix" className='pointer' body={(rowData) => (
                                <span title={rowData.policyPrefix}>
                                    {rowData.policyPrefix?.length > 15 ? `${rowData.policyPrefix.slice(0, 15)}...` : rowData.policyPrefix}
                                </span>
                            )} />


                                <Column
                                    header="Description"
                                    body={(rowData) => (
                                        <a
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                showDescription(rowData.description);
                                            }}
                                            style={{ cursor: 'pointer', color: '#00b0ab', textDecoration: 'underline' }}
                                        >
                                            View Description
                                        </a>
                                    )}
                                />
                                <Column field='createdDate' header="Created Date/Time"
                                    body={(rowData) => new Date(rowData.createdDate).toLocaleString('en-GB', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                    })} />

                                <Column header="Attachment" body={actionDocument} />
                            </DataTable>
                        </div>
                    </div>
                </div>

            </div>

        </>
    );
};

export default TableProcessInformation;
